// 9fbef606107a605d69c0edbcd8029e5d
import constants from './BundleTracker.constants';

export const toggleTracker = (payload) => {
  return {
    type: constants.TOGGLE_TRACKER,
    payload,
  };
};

export const setBundleData = (payload) => {
  return {
    type: constants.SET_BUNDLE_DATA,
    payload,
  };
};
